import type React from 'react';

import type * as api from '@gitbook/api-client';
import { CardSkeleton } from '@gitbook/spine-react';

import { IntegrationCard } from '../../../Components';

/**
 * A list of integrations.
 */
export function IntegrationsList(props: {
    integrations: api.Integration[];
    installedIntegrations: api.InstalledIntegration[];
    organizationId: string;
}): React.ReactElement {
    return (
        <ul className="grid w-full grid-cols-[repeat(auto-fill,_minmax(300px,_1fr))] gap-7">
            {props.integrations.map((integration) => {
                if (!integration.name) {
                    return null;
                }
                return (
                    <li key={integration.name}>
                        <IntegrationCard
                            integration={integration}
                            contentInstallationStatus={
                                props.installedIntegrations.find(
                                    (installedIntegration) =>
                                        installedIntegration.integration.name === integration.name
                                )?.status
                            }
                            organizationId={props.organizationId}
                        />
                    </li>
                );
            })}
        </ul>
    );
}

/** Skeleton for an integrations list loading state */
export function IntegrationsListSkeleton(props: { limit?: number }): React.ReactElement {
    const { limit = 6 } = props;
    return (
        <ul className="grid w-full grid-cols-[repeat(auto-fill,_minmax(300px,_1fr))] gap-7">
            {Array.from({ length: limit }).map((_, index) => (
                // biome-ignore lint/suspicious/noArrayIndexKey: all children are the same, no need for a unique key per element
                <li key={index}>
                    <CardSkeleton />
                </li>
            ))}
        </ul>
    );
}
